import type { RefObject } from "react";

export const VIEW = {
	MONTH: "month",
	YEAR: "year",
	DECADE: "decade",
};
export type CalendarViewType = (typeof VIEW)[keyof typeof VIEW];

export interface DatePickerStyledProps {
	ranged?: boolean;
	calendarView: CalendarViewType;
}

export interface DatePickerProps {
	ranged?: boolean;
	dates: Date | [Date, Date];
	minDate?: Date;
	minDateTooltipContent?: string;
	onChange?: (value: Date | [Date, Date]) => void;
	onClickDay?: (value: Date) => boolean;
	onApply?: (value: Date | [Date, Date], close?: boolean) => void;
	onCancel: () => void;
	className?: string;
	ref?: RefObject<HTMLDivElement>;
}
